import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ROUTES } from '../../../shared/config/routes';
import { formatDateTime, getVoucherExpiryDate } from '../utils/voucherDates';
import VoucherRedeemModal from './VoucherRedeemModal';

const QUICK_OPTIONS = [1, 2, 3];

export default function QuickRedeemPad({ voucher, onRedeem, onOpenHistory, busy }) {
  const expiresAt = getVoucherExpiryDate(voucher.purchaseDate, voucher.expiresAt);
  const [redeemModalOpen, setRedeemModalOpen] = useState(false);

  return (
    <>
      <div className="rounded-[28px] border border-[var(--app-border)] bg-white p-5 space-y-5 shadow-[0_12px_30px_rgba(15,23,42,0.04)]">
        <div className="flex flex-col gap-4 xl:flex-row xl:items-start xl:justify-between">
          <div>
            <p className="text-[11px] uppercase tracking-[0.24em] text-slate-400">Bono {voucher.voucherCode}</p>
            <p className="mt-2 text-[34px] leading-none font-semibold tracking-[-0.04em] text-slate-950">{voucher.hoursAvailable}h</p>
            <div className="mt-3 flex flex-wrap gap-2 text-sm text-slate-500">
              <span className="rounded-full bg-slate-100 px-3 py-1">Comprado {voucher.hoursPurchased}h</span>
              <span className="rounded-full bg-slate-100 px-3 py-1">Vence {formatDateTime(expiresAt)}</span>
            </div>
          </div>
          <div className="rounded-[22px] bg-[rgba(245,245,247,0.9)] border border-[var(--app-border)] px-4 py-3 min-w-[220px]">
            <p className="text-[11px] uppercase tracking-[0.18em] text-slate-400">Último uso</p>
            <p className="mt-2 text-base font-medium text-slate-900">
              {voucher.lastRedeemAt ? formatDateTime(voucher.lastRedeemAt) : 'Sin usos'}
            </p>
          </div>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
          {QUICK_OPTIONS.map((hours) => (
            <button
              key={hours}
              type="button"
              onClick={() => onRedeem(hours)}
              disabled={busy || voucher.hoursAvailable < hours}
              className="min-h-[72px] rounded-[22px] bg-[#0a84ff] hover:bg-[#0077ed] text-white text-[28px] font-semibold tracking-[-0.03em] shadow-[0_14px_25px_rgba(10,132,255,0.18)] disabled:bg-slate-300 disabled:shadow-none"
            >
              {hours}h
            </button>
          ))}
          <button
            type="button"
            onClick={() => setRedeemModalOpen(true)}
            disabled={busy}
            className="min-h-[72px] rounded-[22px] bg-slate-100 hover:bg-slate-200 text-slate-900 text-lg font-medium disabled:bg-slate-100 disabled:text-slate-400"
          >
            Canjear
          </button>
        </div>

        <div className="grid md:grid-cols-2 gap-3">
          <button
            type="button"
            onClick={onOpenHistory}
            className="w-full rounded-[20px] border border-[var(--app-border)] bg-[rgba(245,245,247,0.8)] hover:bg-white text-slate-900 font-medium py-3"
          >
            Ver historial rápido
          </button>
          <Link
            to={ROUTES.adminVoucherDetail.replace(':voucherId', encodeURIComponent(String(voucher.id ?? '')))}
            state={{ voucherPreview: voucher }}
            className="inline-flex w-full items-center justify-center rounded-[20px] border border-[var(--app-border)] bg-[rgba(245,245,247,0.8)] hover:bg-white text-slate-900 font-medium py-3 text-center"
          >
            Abrir detalle
          </Link>
        </div>
      </div>

      {redeemModalOpen && (
        <VoucherRedeemModal
          voucher={voucher}
          busy={busy}
          onClose={() => setRedeemModalOpen(false)}
          onConfirm={async (hours) => {
            const success = await onRedeem(hours);
            if (success) {
              setRedeemModalOpen(false);
            }
            return success;
          }}
        />
      )}
    </>
  );
}
